"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TvShowResults = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ids_components_1 = require("@iress/ids-components");
const Alert_1 = require("./Alert");
const PageSkeleton_1 = require("./PageSkeleton");
const messages_1 = require("./errors/messages");
const TvShowResults = ({ data, isLoading, hasError }) => {
    if (hasError) {
        return (0, jsx_runtime_1.jsx)(Alert_1.Alert, { message: messages_1.API_SEARCH_RESULT_ERROR, status: "danger" });
    }
    if (isLoading) {
        return (0, jsx_runtime_1.jsx)(PageSkeleton_1.PageSkeleton, { count: 3 });
    }
    if (data.length > 0) {
        return ((0, jsx_runtime_1.jsx)(ids_components_1.IressInline, Object.assign({ gutter: "lg", horizontalAlign: "center" }, { children: data.map((tvShow) => ((0, jsx_runtime_1.jsxs)(ids_components_1.IressCard, Object.assign({ "data-testid": "tv-show-item", heading: (0, jsx_runtime_1.jsx)("h4", { children: tvShow.name }), media: (0, jsx_runtime_1.jsx)("img", { alt: tvShow.name, src: tvShow.image }) }, { children: [(0, jsx_runtime_1.jsx)(ids_components_1.IressIcon, { "data-testid": "tv-show-rating-icon", name: "star", screenreaderText: "rating" }), (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "tv-show-rating-icon" }, { children: tvShow.rating }))] }), tvShow.name))) })));
    }
    return (0, jsx_runtime_1.jsx)(Alert_1.Alert, { message: messages_1.NO_RESULT_FOUND, status: "info" });
};
exports.TvShowResults = TvShowResults;
